import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { formatDate } from "../lib/constants";
import { ArrowUpRight, MessageCircle } from "lucide-react";

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news")
      .then((r) => setNews(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="news-page" className="py-24">
      <div className="container-page">
        <div className="eyebrow mb-4">Notícias</div>
        <h1 className="font-display text-5xl md:text-6xl text-forest-900 leading-tight max-w-3xl">
          Histórias da floresta, da cooperativa e dos nossos cooperados.
        </h1>
        <div className="section-divider mt-8" />

        {loading ? (
          <p className="mt-16 text-forest-900/60">Carregando notícias...</p>
        ) : news.length === 0 ? (
          <p className="mt-16 text-forest-900/60">Ainda não publicamos nenhuma notícia. Volte em breve!</p>
        ) : (
          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {news.map((n) => {
              const url = `${window.location.origin}/noticias/${n.slug}`;
              const waText = `📰 ${n.title}\n\n${n.excerpt}\n\nLeia mais no site da COOMFLONA:\n${url}`;
              return (
                <div key={n.id} className="group block">
                  <Link to={`/noticias/${n.slug}`} data-testid={`news-card-${n.slug}`}>
                    <div className="aspect-[4/3] overflow-hidden mb-5">
                      <img src={n.image_url && n.image_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${n.image_url}` : n.image_url} alt={n.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <div className="eyebrow mb-2">{formatDate(n.created_at)} &middot; {n.category}</div>
                    <h2 className="font-display text-2xl md:text-3xl text-forest-900 leading-tight group-hover:text-copaiba-700 transition-colors">{n.title}</h2>
                    <p className="mt-3 text-forest-900/75 line-clamp-3">{n.excerpt}</p>
                  </Link>
                  <div className="mt-4 flex items-center justify-between gap-3">
                    <Link to={`/noticias/${n.slug}`} className="inline-flex items-center gap-1 text-sm text-forest-700 hover:text-copaiba-700">
                      Ler notícia <ArrowUpRight className="w-4 h-4" />
                    </Link>
                    <a
                      href={`https://wa.me/?text=${encodeURIComponent(waText)}`}
                      target="_blank" rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      data-testid={`news-share-${n.slug}`}
                      title="Compartilhar no WhatsApp"
                      className="inline-flex items-center gap-1 text-xs px-2.5 py-1.5 bg-[#25D366] text-white hover:opacity-90"
                    >
                      <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
